@media screen {
    .grid-container {
        background-color: var(--blue-bg);
        background-image: url('/include/images/auth/two-clouds.svg');
        background-size: cover;
        background-position: right;
        background-repeat: no-repeat;
        height: 100%;
        width: 100%;
    }

    .grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: minmax(0, 1fr) minmax(0, 2fr) minmax(0, 4fr);
        min-height: 100vh;
        height: 100%;
        width: 100%;
        gap: 32px 32px;
        padding: 16px 64px;
        box-sizing: border-box;
    }

    .main-header {
        grid-column: 1/3;
        grid-row: 1/2;
    }

    .header {
        grid-column: 1/2;
        grid-row: 2/3;
        font-family: 'Doyle', 'Georgia', 'sans-serif';
        font-weight: 700;
        font-size: min(56px, 4vw);
        line-height: 100%;
        letter-spacing: 0%;
        color: var(--sidebar-primary);
        display: flex;
        justify-content: center;
        align-items: flex-end;
        text-align: center;
    }

    .whats-new {
        grid-column: 1/2;
        grid-row: 3/4;
        display: flex;
        justify-content: center;
        align-items: flex-start;
    }

    .wrapper {
        display: none;
    }

    .form {
        grid-column: 2/3;
        grid-row: 2/4;
        background-color: #fff;
        padding: 48px 64px;
        border-radius: 8px;
        box-shadow: 0 0 10px 0 rgba(60, 106, 120, 0.24);
        justify-self: center;
        align-self: center;
        max-height: 100%;
        height: fit-content;
        width: min(470px, 100%);
        max-width: 100%;
        box-sizing: border-box;
    }
}

@media (max-width: 1100px) {
    .grid-container {
        min-height: 100vh;
        height: fit-content;
    }

    .grid {
        grid-template-columns: 1fr;
        grid-template-rows: 60px auto auto;
        padding: 16px 32px;
        gap: 32px 0;
    }

    .header {
        font-size: max(28px, 3.3vw);
        line-height: 48px;
    }

    .form {
        grid-column: initial;
        grid-row: 3/3;
        align-self: start;
    }

    .whats-new {
        display: none;
    }
}

@media (max-width: 744px) {
    .form {
        padding: 48px 32px;
        width: min(405px, 100%);
    }

    .header {
        font-size: 28px;
        line-height: 40px;
    }
}
